import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Unified status pill for game states: live | scheduled | ended | suspended.
 * Colors, label, and data-testid are derived from the status prop.
 */
export default function StatusPill({ status, className = "", asButton = false, onClick, title }) {
  const { t } = useTranslation();
  const s = status || "live";

  const palette = {
    live: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30",
    scheduled:
      "bg-blue-500/15 text-blue-600 dark:text-blue-300 border-blue-500/30",
    ended: "bg-zinc-500/15 text-zinc-600 dark:text-zinc-300 border-zinc-500/30",
    suspended:
      "bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/30",
  };

  const label = t(`status.${s}`);

  const base =
    "inline-flex items-center gap-1.5 rounded-full text-[10px] font-semibold tracking-wider uppercase px-2.5 py-1 border transition-all";

  const dotColor = {
    live: "bg-emerald-500 animate-pulse",
    scheduled: "bg-blue-500",
    ended: "bg-zinc-400",
    suspended: "bg-amber-500",
  }[s];

  if (asButton) {
    return (
      <button
        type="button"
        onClick={onClick}
        title={title}
        data-testid={`status-pill-${s}`}
        data-status={s}
        className={`${base} ${palette[s]} hover:scale-[1.03] active:scale-[0.98] ${className}`}
      >
        <span className={`h-1.5 w-1.5 rounded-full ${dotColor}`} />
        {label}
      </button>
    );
  }

  return (
    <span
      data-testid={`status-pill-${s}`}
      data-status={s}
      className={`${base} ${palette[s]} ${className}`}
      title={title}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dotColor}`} />
      {label}
    </span>
  );
}
